/* slick-shim.js — No-op shim voor pagina's zonder Slick-slider
 * Voorkomt JavaScript-errors in wbcustom.js op pagina's waar
 * slick.min.js niet geladen wordt (alles behalve product/index/collection).
 */
;(function ($) {
  'use strict';
  if (!$) return;
  var noop = function () { return this; };
  $.fn.slick        = $.fn.slick        || noop;
  $.fn.unslick      = $.fn.unslick      || noop;
  $.fn.slickAdd     = $.fn.slickAdd     || noop;
  $.fn.slickRemove  = $.fn.slickRemove  || noop;
  $.fn.slickGoTo    = $.fn.slickGoTo    || noop;
  $.fn.slickNext    = $.fn.slickNext    || noop;
  $.fn.slickPrev    = $.fn.slickPrev    || noop;
  $.fn.slickPause   = $.fn.slickPause   || noop;
  $.fn.slickPlay    = $.fn.slickPlay    || noop;
  $.fn.slickFilter  = $.fn.slickFilter  || noop;
  $.fn.slickGetOption = $.fn.slickGetOption || noop;
  $.fn.slickSetOption = $.fn.slickSetOption || noop;
}(window.jQuery));
